<template>
  <div
    @click="selectChannel"
    :class="{'channel': true, selected}">

    <div class="channel-heading">
      <div class="channel-status">
        <check-box
          v-if="connected"
          :active="{channelSelected: selected}"
          class="mr-1 inlined"
          name="channelSelected"
          value="select" />
          
        <div
          v-if="channelIcon !== null"
          class="icon inlined">

          <q-image
            :pack="getIconPack"
            :name="getIconName"
            width="30px"
            height="30px" />
            
        </div>

        <!-- div
          class="inlined channel-selects d-none d-md-flex"
          v-if="connected">

          <input-select
            variant="standardInput"
            inputLabel="Posts per day"
            inputPlaceholder="Posts per day"
            small
            slimmer
            class="ml-3 shorter-input channel-item inlined scaled"
            inputName="procantageSelect"
            :selectOptions="getPostcountOptions"
            :defaultValue="getPostsPerDay"
            @fieldUpdate="setPostsPerDayCount" />

          <input-button
            v-if="selected"
            variant="standardInput"
            hollow
            smaller
            btnStyle="ok-style"
            iconLeft="calendar"
            class="shorter-input channel-item inlined scaled reschedule"
            @click="requestSchedualeEdit"
            inputPlaceholder="Edit schedule" />

        </div -->

        <div
          class="inlined not-connected"
          v-if="!connected">

          <p class="text">
            <small>
              {{ $t('Campaigns.channel') }}
            </small>
            <br />
            <b>
              {{ $t(getUnconnectedLabel) }}
            </b>
          </p>
        </div>

        <div v-else>
          <!-- Channel board label -->
          <div v-if="connected">
            <p class="d-none d-md-block board-label m-0 ml-3 mr-3">
              {{ label }}
            </p>
            <p class="d-block d-md-none board-label normal m-0 ml-3 mr-3">
              {{ label }}
            </p>
          </div>
        </div>

      </div>
      <div class="right-channel-actions">
        <input-button
          v-if="!connected && !falseUnconnected"
          variant="standardInput"
          hollow
          smaller
          btnStyle="ok-style"
          class="shorter-input channel-item inlined"
          :inputPlaceholder="$t('Button.connect')"
          @click="requestConnector" />

        <router-link
          v-else-if="falseUnconnected"
          :to="{ name: 'userConnections' }">

          <input-button
            variant="standardInput"
            hollow
            smaller
            btnStyle="ok-style"
            class="shorter-input channel-item inlined"
            :inputPlaceholder="$t('Button.edit')" />

        </router-link>
      </div>
    </div>

    <!-- div
      v-if="connected && false"
      class="channel-body d-block d-md-none m-0 row">

        <input-select
          variant="standardInput"
          inputLabel="Posts per day"
          small
          slimmer
          stretched
          inputName="procantageSelect"
          :selectOptions="getPostcountOptions"
          :defaultValue="getPostcountOptions[0].val"
          @fieldUpdate="fieldUpdate" />

        <input-button
          v-if="selected"
          variant="standardInput"
          hollow
          smaller
          class="sceduale-button float-right"
          btnStyle="ok-style"
          iconLeft="calendar"
          @click="requestSchedualeEdit"
          :inputPlaceholder="$t('Button.edit')" />

    </div -->
  </div>
</template>

<script>
import FormCheckbox from '@/components/standard/form/FormCheckbox'
import CheckBox from '@/components/standard/form/customItems/CheckBox'
import InputButton from '@/components/standard/input/InputButton'
import InputSelect from '@/components/standard/input/InputSelect'
import QImage from '@/components/standard/display/QImage'

export default {
  data () {
    return {
      perDayCount: 0,
      dayEvents: {},
      iconSize: 1.3
    }
  },

  methods: {
    /**
     * Sets posts per day counter for given board
     * @param {Object} e StandardInput 
     */
    // setPostsPerDayCount (e) {
    //   this.perDayCount = e.values
    // },

    /**
     * Openes a channel connector for given channel
     */
    requestConnector () {
      this.$bus.emit('connectChannel', { type: this.channelName });
    },

    /**
     * Requests a schedule edit for given channel board
     */
    // requestSchedualeEdit () {
    //   this.$emit('requestSchedualeEdit', {
    //     refName: this.uuid,
    //     dayEvents: this.dayEvents
    //   })
    // },

    /**
     * Emits request to select this channel board
     */
    selectChannel () {
      if(!this.connected) return false

      this.$emit('channelSelected', {
        selected: !this.selected,
        channel: this.channelName,
        identity: this.identity
      })
    }
  },

  computed: {
    /**
     * Tells how manny post/day based on user's schedule
     * @returns {Number}
     */
    // getPostsPerDay () {
    //   let maxPerDay = 0
    //   for (let day of Object.values(this.dayEvents)) {
    //     maxPerDay = Math.max(maxPerDay, Object.keys(day).length)
    //   }
    //   maxPerDay = (maxPerDay === 0) ? this.perDayCount : maxPerDay
    //   return maxPerDay
    // },

    /**
     * Gives channel icon object - name, pack, etc.
     * @returns {Object}
     */
    getChannelIconObject () {
      return this.channelIcon || {}
    },

    /**
     * Gives channel icon name
     * @returns {String}
     */
    getIconName () {
      return this.getChannelIconObject.name
    },

    /**
     * Gives channel icon pack
     * @returns {String}
     */
    getIconPack () {
      return this.getChannelIconObject.pack
    },

    /**
     * Gives channel name
     * @returns {String}
     */
    getChannelName () {
      return this.channelName
    },

    /**
     * GIves channels label if it is not connected
     * @returns {String}
     */
    getUnconnectedLabel () {
      return (this.falseUnconnected) ? 'Campaigns.selectChannels.falseUnconnected' : 'Campaigns.selectChannelsNotConnected'
    }

    /**
     * Gives an array of posts/day options
     * @returns {Array}
     */
    // getPostcountOptions () {
    //   let rtr = [{
    //     val: null,
    //     label: 'Posts per day'
    //   }]

    //   for (let i = 1; i <= 6; i++) {
    //     rtr.push({
    //       val: i,
    //       label: `${i} post${i > 1 ? 's' : ''} per day`
    //     })
    //   }

    //   return rtr
    // }
  },

  components: {
    'q-image': QImage,
    'input-button': InputButton,
    'input-select': InputSelect,
    'form-checkbox': FormCheckbox,
    'check-box': CheckBox
  },
  props: {
    falseUnconnected: {
      type: Boolean,
      required: false,
      default: false
    },

    label: {
      type: String,
      required: false,
      default: ''
    },
    uuid: {
      type: String,
      required: false,
      default: null
    },
    identity: {
      type: String,
      required: false,
      default: ''
    },
    connected: {
      type: Boolean,
      required: false,
      default: false
    },
    channelName: {
      type: String,
      required: true,
      default: ''
    },
    channelIcon: {
      required: false,
      type: Object,
      default: null
    },
    selected: {
      type: Boolean,
      required: true,
      default: false
    }
  }

}
</script>

<style scoped>
.sceduale-button {
  margin-top: 5px;
}
.channel {
  margin-bottom: 15px!important;
  background-color: #FFF;
  min-height: 70px;
  border-radius: 4px;
  padding: 0!important;
  /*padding-top: 18px!important;*/
  padding-bottom: 18px!important;
  /*padding-top: 28px!important;*/
  padding-top: 18px!important;

  border: 1px solid transparent;
  cursor: pointer;
  transition: all .3s;
}
.channel:hover {
  border: 1px solid #35363525;
}
.channel.selected {
  border-color: #7AC14345;
}
.channel.selected:hover {
  border-color: #FE2B4125;
}

.board-label {
  font-size: 15px;
  color: #353635;
  /*position: absolute;
  top: 8px;
  left: 0;*/
}

.board-label.normal {
  position: unset;
  top: unset;
  left: unset;
}

.channel-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 14px;
  padding-right: 24px;
}

.channel-body {
  padding: 13px;
  padding-top: 0;
  margin-top: 10px!important;
  border-top: 1px solid #F8F8F8;
}

.reschedule {
  position: relative;
  margin-top: 11px;
}
.channel-selects {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-flow: wrap;
}
.channel-status {
  display: flex;
  align-items: center;
  justify-content: center;
}
.text {
  margin-left: 20px!important;
}

.not-connected .text {
  margin: 0;
  line-height: 19px;
}
.scaled {
  width: 203px;
}
span {
  margin-left: 5px;
}

@media (max-width: 768px) {
  .channel {
    margin-bottom: 5px!important;
    padding-top: 9px!important;
    padding-bottom: 14px!important;
  }

  .channel-heading {
    padding-left: 13px;
    padding-right: 13px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/standard/channels/Channel.vue?6d9f37cb